<footer class="landing-footer">
  <div class="footer-inner">
    <div class="footer-brand">
      <img
        src="../../../assets/images/gemfin-logo.svg"
        alt="GemFin Logo"
        class="footer-logo"
      />
      <p class="footer-tagline">
        Empowering Smarter Investments<br />One Dashboard at a Time.
      </p>
      <!-- <div class="footer-social">
        <a href="#" (click)="preventRedirect($event)" aria-label="LinkedIn"
          ><i class="pi pi-linkedin"></i
        ></a>
        <a href="#" (click)="preventRedirect($event)" aria-label="Twitter"
          ><i class="pi pi-twitter"></i
        ></a>
      </div> -->
    </div>
    <div class="footer-links">
      <div class="footer-col">
        <h4>About</h4>
        <a href="#" (click)="preventRedirect($event)">Features</a>
        <a href="#" (click)="preventRedirect($event)">Services</a>
        <a href="#" (click)="preventRedirect($event)">Blog</a>
      </div>
      <div class="footer-col">
        <h4>Contact</h4>
        <span><i class="pi pi-envelope"></i> getintouch&#64;gemfin.in</span>
        <span><i class="pi pi-phone"></i> +91 95557 11607</span>
        <span
          ><i class="pi pi-map-marker"></i> Plot No. 119, Udyog Vihar, Phase I,
          Sector 20, Gurugram, Haryana 122016</span
        >
      </div>
    </div>
  </div>
  <div class="footer-bottom">
    <span>Copyright &#64; 2026 GemFin. All rights reserved.</span>
    <!-- <div class="footer-bottom-links">
      <a href="#" (click)="preventRedirect($event)">Terms and Conditions</a>
      <a href="#" (click)="preventRedirect($event)">Privacy Policy</a>
    </div> -->
  </div>
</footer>
